import { fetchJson } from './index';
import { apiUrl } from '../constants';
import { stringify } from 'query-string';
import formatData from './formatData';

// Define types for the customQuery method
interface CustomQueryParams {
  type: 'GET_LIST' | 'GET_ONE' | 'CREATE' | 'UPDATE' | 'DELETE';
  resource: string;
  payload: {
    filter?: Record<string, any>;
    id?: string | number;
    data?: any;
    [key: string]: any;
  };
}

// Create a customized dataProvider with the customQuery method
const customDataProvider = (dataProvider: any) => {
  // Helper function to handle GET_LIST requests
  const handleGetList = (resource: string, payload: any, formatter?: Function) => {
    const { filter = {}, pagination = { page: 1, perPage: 100 }, sort = { field: 'createdAt', order: 'DESC' } } = payload;
    
    // Build query parameters
    const query = {
      filter: JSON.stringify(filter),
      range: JSON.stringify([
        (pagination.page - 1) * pagination.perPage,
        pagination.page * pagination.perPage - 1,
      ]),
      sort: JSON.stringify([sort.field, sort.order]),
    };
    
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    
    return fetchJson(url).then(({ json }) => {
      let dataArray = [];
      
      if (json) {
        // Extract data array from response, handling different response formats
        if (Array.isArray(json)) {
          dataArray = json;
        } else if (json.data && Array.isArray(json.data)) {
          dataArray = json.data;
        } else if (typeof json === 'object') {
          dataArray = [json];
        }
        
        // Apply formatter if provided
        if (formatter && typeof formatter === 'function') {
          dataArray = dataArray.map((item: any) => formatter(item));
        }
      }
      
      return { 
        data: dataArray, 
        total: dataArray.length 
      };
    });
  };

  return {
    ...dataProvider,
    customQuery: ({ type, resource, payload }: CustomQueryParams) => {
      // Handle GET_LIST requests
      if (type === 'GET_LIST') {
        if (resource === 'user/settlementMapping') {
          return handleGetList(resource, payload, (item: any) => formatData('settlementMapping', item));
        }
        
        if (resource === 'user/settlementTypes') {
          return handleGetList(resource, payload);
        }
      }
      
      // Handle UPDATE for user/settlementTypes
      if (type === 'UPDATE' && resource === 'user/settlementTypes') {
        const { id, data } = payload;
        const url = `${apiUrl}/${resource}/${id}`;
        
        return fetchJson(url, {
          method: 'PUT',
          body: JSON.stringify(data),
        }).then(({ json }) => ({ data: json }));
      }
      
      // Handle other custom queries as needed
      return Promise.reject(new Error(`Unsupported custom query type: ${type} for resource: ${resource}`));
    }
  };
};

export default customDataProvider; 